import type { Command } from 'commander';
import { isConfigKey, loadConfig } from '../../lib/config-store';
import { CliError, ExitCode } from '../../lib/errors';
import { printJson } from '../../lib/output';

export function registerConfigGet(parent: Command): void {
	parent
		.command('get [key]')
		.description('Print config value(s). With no key, prints the whole config as JSON.')
		.action((key: string | undefined) => {
			const config = loadConfig();
			if (key === undefined) {
				printJson(config);
				return;
			}
			if (!isConfigKey(key)) {
				throw new CliError(
					`Unknown config key "${key}". Allowed: locale, output, timeout_ms`,
					ExitCode.InvalidArgument
				);
			}
			const value = (config as Record<string, unknown>)[key];
			if (value === undefined) {
				process.stdout.write('\n');
				return;
			}
			process.stdout.write((typeof value === 'string' ? value : JSON.stringify(value)) + '\n');
		});
}
